/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateLeadsubcategoryDto } from '../models/work-create-leadsubcategory-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkLeadsubcategory } from '../models/work-leadsubcategory';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateLeadsubcategoryDto } from '../models/work-update-leadsubcategory-dto';

@Injectable({ providedIn: 'root' })
export class WorkLeadSubCategoriesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `leadsubcategoriesV2ControllerGetAllDropdownOptions()` */
  static readonly LeadsubcategoriesV2ControllerGetAllDropdownOptionsPath = '/v2/leadsubcategories/dropdown-options';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leadsubcategoriesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  leadsubcategoriesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLeadSubCategoriesV2Service.LeadsubcategoriesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leadsubcategoriesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  leadsubcategoriesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.leadsubcategoriesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `leadsubcategoriesV2ControllerFindAllPaginated()` */
  static readonly LeadsubcategoriesV2ControllerFindAllPaginatedPath = '/v2/leadsubcategories';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leadsubcategoriesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  leadsubcategoriesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by name query param.
     *           <p>
     *              <b>Format: </b> filter.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.name=$not:$like:John Doe&filter.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.name'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by leadcategoryId query param.
     *           <p>
     *              <b>Format: </b> filter.leadcategoryId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.leadcategoryId=$not:$like:John Doe&filter.leadcategoryId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.leadcategoryId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li>
     * <li>leadcategoryId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'active:ASC' | 'active:DESC' | 'leadcategoryId:ASC' | 'leadcategoryId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,active
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkLeadsubcategory>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'name'?: (string | Array<string>);
'active'?: (string | Array<string>);
'leadcategoryId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLeadSubCategoriesV2Service.LeadsubcategoriesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.name', params['filter.name'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.leadcategoryId', params['filter.leadcategoryId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkLeadsubcategory>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'name'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        'leadcategoryId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leadsubcategoriesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  leadsubcategoriesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by name query param.
     *           <p>
     *              <b>Format: </b> filter.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.name=$not:$like:John Doe&filter.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.name'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by leadcategoryId query param.
     *           <p>
     *              <b>Format: </b> filter.leadcategoryId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.leadcategoryId=$not:$like:John Doe&filter.leadcategoryId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.leadcategoryId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li>
     * <li>leadcategoryId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'active:ASC' | 'active:DESC' | 'leadcategoryId:ASC' | 'leadcategoryId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,active
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkLeadsubcategory>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'name'?: (string | Array<string>);
'active'?: (string | Array<string>);
'leadcategoryId'?: (string | Array<string>);
};
};
}> {
    return this.leadsubcategoriesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkLeadsubcategory>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'name'?: (string | Array<string>);
'active'?: (string | Array<string>);
'leadcategoryId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkLeadsubcategory>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'name'?: (string | Array<string>);
'active'?: (string | Array<string>);
'leadcategoryId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `leadsubcategoriesV2ControllerCreate()` */
  static readonly LeadsubcategoriesV2ControllerCreatePath = '/v2/leadsubcategories';

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leadsubcategoriesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsubcategoriesV2ControllerCreate$Response(
    params: {
      body: WorkCreateLeadsubcategoryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLeadsubcategory>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLeadSubCategoriesV2Service.LeadsubcategoriesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLeadsubcategory>;
      })
    );
  }

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leadsubcategoriesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsubcategoriesV2ControllerCreate(
    params: {
      body: WorkCreateLeadsubcategoryDto
    },
    context?: HttpContext
  ): Observable<WorkLeadsubcategory> {
    return this.leadsubcategoriesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLeadsubcategory>): WorkLeadsubcategory => r.body)
    );
  }

  /** Path part for operation `leadsubcategoriesV2ControllerDelete()` */
  static readonly LeadsubcategoriesV2ControllerDeletePath = '/v2/leadsubcategories/{id}';

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leadsubcategoriesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  leadsubcategoriesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLeadSubCategoriesV2Service.LeadsubcategoriesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leadsubcategoriesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  leadsubcategoriesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.leadsubcategoriesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `leadsubcategoriesV2ControllerUpdate()` */
  static readonly LeadsubcategoriesV2ControllerUpdatePath = '/v2/leadsubcategories/{id}';

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `leadsubcategoriesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsubcategoriesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateLeadsubcategoryDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLeadsubcategory>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLeadSubCategoriesV2Service.LeadsubcategoriesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLeadsubcategory>;
      })
    );
  }

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `leadsubcategoriesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  leadsubcategoriesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateLeadsubcategoryDto
    },
    context?: HttpContext
  ): Observable<WorkLeadsubcategory> {
    return this.leadsubcategoriesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLeadsubcategory>): WorkLeadsubcategory => r.body)
    );
  }

}
